<template>
  <div class="description-side">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1881.85 655.42"
      class="background -logo"
    >
      <g>
        <g>
          <g>
            <g>
              <path class="component"
                d="M362.94,19h12a20.68,20.68,0,0,0,3.76,1.11,83.28,83.28,0,0,1,43,17.06q99.82,76,199.82,151.82a66.76,66.76,0,0,1,10.57,9.86c18.46,21.82,23.43,46.76,18.46,74.72-4.44,25-7.26,50.34-10.75,75.53s-6.88,50.39-10.38,75.58q-5.76,41.49-11.64,83c-4.29,29.9-20.07,52.41-47.65,63.81Q450.46,620.88,329.8,667.9c-26.47,10.37-53.21,6.84-76-10.13Q150.42,580.7,48.35,501.85C26,484.59,17.12,460,19.36,431.92c1.09-13.56,3.8-27,5.66-40.49,4.46-32.44,8.8-64.89,13.3-97.33,5.17-37.2,10.16-74.44,15.79-111.58,4.41-29.06,20.66-50.36,47.39-61.76Q166,93.25,231.58,68.48C275.32,51.85,317.11,30.05,362.94,19ZM469.46,564.54c-2.22-1.8-3.46-2.86-4.75-3.86-21.82-16.73-43.59-33.52-65.47-50.17Q287.64,425.63,176,340.79c-2.4-1.82-4.36-2.82-7.6-1.5q-46.2,18.81-92.57,37.24c-2.89,1.15-4,2.76-4.35,5.82-2,15.66-4,31.33-6.67,46.89-2.76,16.09.49,30,13.79,40.12q99.78,76,199.85,151.75c11.48,8.68,24.46,10.21,37.8,4.92,39.88-15.83,79.67-31.89,119.49-47.87C446.66,573.77,457.57,569.34,469.46,564.54Zm-7.32-440.63c-1,7.8-1.92,14.36-2.8,20.91q-4.8,35.6-9.61,71.17c-3.15,23.56-6.22,47.13-9.37,70.69q-4.29,32.13-8.66,64.25-4.31,31.88-8.59,63.75-3.21,24-6.38,48c-.38,2.82-.36,5.22,2.49,7.38,31.84,24.2,63.52,48.61,95.39,72.77a8,8,0,0,0,6.59.88c10.14-3.73,20.24-7.64,30.12-12,11.75-5.2,19.08-14.52,21.56-27,2-10.26,3-20.73,4.38-31.1q4.75-34.33,9.52-68.66,5.24-37.78,10.49-75.57c3.17-22.88,6.19-45.79,9.58-68.64,2.35-15.91-2.17-28.84-15.12-38.66q-61.93-47-123.84-94C466.34,126.85,464.73,125.76,462.14,123.91ZM79.32,327.27c2.8-1,4.67-1.61,6.49-2.34q155.61-62.42,311.28-124.68c7.29-2.91,10.7-6.31,11.61-14.56,3.32-29.9,7.62-59.7,11.76-89.5.42-3-.49-4.6-2.68-6.23-8.15-6.08-16.18-12.32-24.33-18.4-11.75-8.78-24.68-10.48-38.21-5.23C333.07,74.94,311.06,84,289,92.83q-83.6,33.54-167.18,67.09c-12.16,4.88-20,13.9-22.94,26.46-2.17,9.35-2.87,19.06-4.2,28.6q-6.4,45.95-12.78,91.88C81,313.37,80.24,319.91,79.32,327.27Zm293.21,106.8c8.71-62.87,17.24-124.37,25.93-187L221.34,318.16Z"
                transform="translate(-19.03 -18.31)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>

    <svg
      viewBox="0 0 1531 891"
      preserveAspectRatio="xMidYMax slice"
      xmlns="http://www.w3.org/2000/svg"
      class="background -circles"
    >
      <path d="M1405 848c-424.366 158.009-437-164-437-272s102-425 563-576v769c-21.333 29.333-63.333 55.667-126 79z" />
      <path d="M1531 162c-122.914-17.284-377.96 33.191-543.433 206.414C822.095 541.636 797.342 648.75 835.842 731.622c38.5 82.871 198.243 134.841 400.555 92.053C1438.71 780.886 1492.752 775.894 1531 768V162z" />
    </svg>

    <div class="content">
      <h1 class="title">
        {{ dashboardConfig.pages.auth.hero.title }}
      </h1>

      <div class="description">
        <p>
          {{ dashboardConfig.pages.auth.hero.description }}
        </p>
      </div>

      <div class="actions" v-if="dashboardConfig.pages.auth.hero.action">
        <a :href="dashboardConfig.pages.auth.hero.action.link" class="btn-more-info" target="_blank">
          {{ dashboardConfig.pages.auth.hero.action.title }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'DescriptionSide',

  computed: {
    ...mapState('dashboard', [
      'dashboardConfig',
    ]),
  },
};
</script>

<style lang="scss" scoped>
  .description-side {
    display: none;

    @media (min-width: 768px) {
      width: 55%;
      height: 100%;
      background: rgb(0,0,255);
      background: linear-gradient(45deg, rgba(0,0,255,1) 0%, rgba(204,5,166,1) 100%);
      color: #fff;
      position: fixed;
      top: 0;
      right: 0;
      display: flex;
      flex: 1 1 auto;
      align-items: center;
      justify-content: center;
      order: 2;
      overflow: hidden;

      > .background {
        position: absolute;
        left: 0;
        height: 900px;
        pointer-events: none;

        path {
          fill: #e5edff;
          opacity: .1;
        }

        &.-logo {
          width: 500%;
          top: 0;
        }

        &.-circles {
          width: 100%;
          top: -10%;
          transform: scaleX(-1);
        }
      }

      > .content {
        position: relative;
        display: flex;
        flex-direction: column;
        max-width: 480px;
        width: 100%;
        margin: 64px;

        > .title {
          @apply text-4xl;
          @apply font-bold;

          line-height: 2.25rem;
        }

        > .description {
          opacity: .7;
          margin-top: 12px;
          font-size: 15px;
        }

        > .actions {
          > .btn-more-info {
            width: 260px;
            margin-top: 40px;
            box-shadow: 0 0 0 0 rgba(0,0,0,.2), 0 0 0 0 rgba(0,0,0,.14), 0 0 0 0 rgba(0,0,0,.12);
            border: 1px solid #ffffff;
            padding: 0 15px;
            display: inline-flex!important;
            align-items: center;
            justify-content: center;
            height: 40px;
            min-height: 40px;
            max-height: 40px;
            line-height: 1!important;
            border-radius: 4px;
            color: #ffffff;
            transition: background-color 150ms ease-in-out;

            &:hover {
              background-color: rgba(255, 255, 255, 0.1);
            }
          }
        }
      }
    }
  }
</style>
